export const API_BASE_URL = "https://crmapi.magicgroupmusic.com"

